export class Logger {
    constructor(name) {
        this.name = name;
    }
    error(...args) {
        console.error(...args);
    }
    warn(msg) {
        console.warn(`[${this.name}] ${msg}`);
    }
    debug(msg) {
        console.log(`[${this.name}] ${new Date().toLocaleTimeString()}: ${msg}`);
    }
}
